import { Component, Input } from '@angular/core';
import { LibraryGroup } from '../../models/chat-library.models';
import { LibraryGroupComponent } from '../library-group/library-group.component';
import { AssetVersionPipe } from '../../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-library-group-list',
  standalone: true,
  imports: [LibraryGroupComponent, AssetVersionPipe],
  templateUrl: './library-group-list.component.html',
  styleUrl: './library-group-list.component.scss',
})
export class LibraryGroupListComponent {
  @Input() groups: LibraryGroup[] = [];
}
